import type { Environment, Services } from '@/types'
import { z } from 'zod'

export const envUrlByService: Record<Services, Record<Environment, string>> = {
  'user-manager': {
    production: 'https://user-manager.alume.com',
    staging: 'https://user-manager-staging.alume.com',
    development: '',
  },
  'accounting-dealer': {
    production: 'https://accounting-dealer.alume.com',
    staging: 'https://accounting-staging.alume.com',
    development: '',
  },
  financial: {
    production: 'https://financial.alume.com',
    staging: 'https://financial-staging.alume.com',
    development: '',
  },
}
export const clickSignWidgetUrl = {
  production: 'https://app.clicksign.com',
  staging: 'https://sandbox.clicksign.com',
  development: '',
  test: '',
}
const envSchema = z.object({
  MODE: z.enum(['production', 'staging', 'development', 'test']),
})

export const env = envSchema.parse(import.meta.env)
